import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsEventObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The event object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'Time at which the event was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The object the event is about.',
                heading: 'object',
                subheading: 'object',
              },
              {
                description: 'The type of object included in the event.',
                heading: 'objectType',
                subheading: 'string',
              },
              {
                description: 'The type of event.',
                heading: 'type',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example event object:</div>
          <Highlight lang="json">
            {`{
  "created": "2017-07-15T22:11:00.000Z",
  "object": {
    "id": "553c3ef8b8cdcd1501ba1238",
    "author": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "2017-07-15T22:11:00.000Z",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "board": {
      "id": "553c3ef8b8cdcd1501ba1234",
      "created": "2017-07-15T22:11:00.000Z",
      "name": "Feature Requests",
      "postCount": 123,
      "url": "https://your-company.canny.io/admin/board/feature-requests"
    },
    "commentCount": 10,
    "created": "2017-07-15T22:11:00.000Z",
    "details": "Test post details",
    "eta": "February 2020",
    "imageURLs": [
      "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
      "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
    ],
    "score": 72,
    "status": "in progress",
    "title": "An awesome feature request",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
  },
  "objectType": "post",
  "type": "post.created"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
